import { Card } from "@material-ui/core";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { SectionHeaderSmall } from "./Primitives";

type Props = { link: string; onDelete: () => void };

export const ApplicantLinkField = ({ link, onDelete }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <Card className="blackDalBorder" style={{ display: "flex", height: 76, alignItems: "center", padding: 25 }}>
            <div
                style={{
                    display: "flex",
                    flex: 3,
                    overflow: "hidden",
                    gap: 16
                }}
            >
                <img src={THEME.Images.icLink} alt="" />
                <SectionHeaderSmall
                    label={link}
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap"
                    }}
                />
            </div>
            <div
                style={{
                    display: "flex",
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 60,
                    marginRight: isMobile ? undefined : 30
                }}
            >
                <img
                    src={THEME.Images.icOpennewtab}
                    alt=""
                    onClick={() => window.open(link, "_blank")}
                    style={{ cursor: "pointer" }}
                />
                <img src={THEME.Images.icDelete} alt="" onClick={onDelete} style={{ cursor: "pointer" }} />
            </div>
        </Card>
    );
};
